import PropertyDetails from "@/components/PropertyDetails";
import React from "react";
import EnergyLabel from "../EnergyLabel";

interface EnergyLabelDetailsProps {
  label: string;
  energyLabel: string;
  info?: string;
}

const EnergyLabelDetails: React.FC<EnergyLabelDetailsProps> = ({
  label,
  energyLabel,
}) => {
  return (
    <PropertyDetails label={label} value={energyLabel} showUnit={false}>
      <EnergyLabel energyLabel={energyLabel} />
    </PropertyDetails>
  );
};

export default EnergyLabelDetails;
